export default __webpack_public_path__ + "static/media/Living_room.f3f4ffef.png";